module.exports = __webpack_public_path__ + "static/img/tip-1.ef65b5f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/usdt5/tip-1.png
// module id = XBIu
// module chunks = 1